import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
import styled from "styled-components";
import { variant } from "styled-system";
import Text from "../text/Text";
export const MINI_TAG_HEIGHT = 12;
export const StyledMiniTag = styled(Text).withConfig({ displayName: "StyledMiniTag_APC-7281-productShell", componentId: "sc-1mjg0v" })(({ theme }) => variant({
    prop: "miniTagVariant",
    variants: {
        "filter-pill": {
            background: theme.colors.apolloColorBackgroundMiniTagFilterPill,
            color: theme.colors.apolloColorTextMiniTagFilterPill,
        },
        neutral: {
            background: theme.colors.apolloColorBackgroundMiniTagNeutral,
            color: theme.colors.apolloColorTextMiniTagNeutral,
        },
        "other-1": {
            background: theme.colors.apolloColorBackgroundMiniTagOther1,
            color: theme.colors.apolloColorTextMiniTagOther1,
        },
        "other-2": {
            background: theme.colors.apolloColorBackgroundMiniTagOther2,
            color: theme.colors.apolloColorTextMiniTagOther2,
        },
        "other-3": {
            background: theme.colors.apolloColorBackgroundMiniTagOther3,
            color: theme.colors.apolloColorTextMiniTagOther3,
        },
        "other-4": {
            background: theme.colors.apolloColorBackgroundMiniTagOther4,
            color: theme.colors.apolloColorTextMiniTagOther4,
        },
        "other-5": {
            background: theme.colors.apolloColorBackgroundMiniTagOther5,
            color: theme.colors.apolloColorTextMiniTagOther5,
        },
        "other-6": {
            background: theme.colors.apolloColorBackgroundMiniTagOther6,
            color: theme.colors.apolloColorTextMiniTagOther6,
        },
        "other-7": {
            background: theme.colors.apolloColorBackgroundMiniTagOther7,
            color: theme.colors.apolloColorTextMiniTagOther7,
        },
        benchmark: {
            background: theme.colors.apolloColorBackgroundMiniTagBenchmark,
            color: theme.colors.apolloColorTextMiniTagBenchmark,
        },
    },
}), ({ theme, disabled }) => (Object.assign({ display: "inline-flex", height: MINI_TAG_HEIGHT, padding: `0 ${apolloSpaceInsetHalfX}`, border: `1px solid ${theme.colors.apolloColorStrokeMiniTag}`, borderRadius: "4px", lineHeight: "100%", boxSizing: "border-box" }, (disabled && {
    background: theme.colors.apolloColorBackgroundMiniTagDisabled,
    color: theme.colors.apolloColorTextDisabled,
}))));
//# sourceMappingURL=MiniTag.style.js.map